export { default } from "./ClaimDetails.gql";
